import { Money, type CreateExpenseInput } from '@chukua/common';

export interface ExpenseFormValues {
  driverId: string;
  truckId: string;
  categoryCode: string;
  /** Major units, as typed: 1,250.50 */
  amount: number;
  note?: string;
  litres?: number;
  station?: string;
  odometerKm?: number;
}

/** The form's major-unit amount becomes integer minor units through `Money`, never float maths here. Fuel fields go only when the category takes them. */
export function toCreateExpenseInput(values: ExpenseFormValues, categoryCapturesFuel: boolean): CreateExpenseInput {
  const fuel =
    categoryCapturesFuel && values.litres !== undefined && values.station && values.odometerKm !== undefined
      ? { litres: values.litres, station: values.station, odometerKm: values.odometerKm }
      : undefined;
  return {
    driverId: values.driverId,
    truckId: values.truckId,
    categoryCode: values.categoryCode,
    amount: Money.parse(values.amount.toFixed(2), 'KES').toJSON(),
    note: values.note?.trim() || undefined,
    fuel,
  };
}
